var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconThrill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0625 23.6523C29.0625 23.1836 28.8867 22.7734 28.6523 22.3633L22.0898 11.875H15.1758L11.543 15.5078C11.3672 15.6836 11.0742 15.6836 10.8984 15.5078L7.61719 12.2266L1.28906 22.3633C1.05469 22.7734 0.9375 23.1836 0.9375 23.6523C0.9375 24.9414 1.93359 25.9375 3.22266 25.9375H26.7188C28.0078 25.9375 29.0625 24.9414 29.0625 23.6523ZM21.5039 10.9375L15.9961 2.14844C15.7617 1.79688 15.4102 1.5625 15 1.5625C14.5898 1.5625 14.1797 1.79688 13.9453 2.14844L8.14453 11.4648L8.26172 11.582L11.25 14.5117L14.6484 11.1133C14.707 10.9961 14.8242 10.9375 15 10.9375H21.5039ZM3.22266 26.875C1.46484 26.875 0 25.4102 0 23.6523C0 23.0078 0.175781 22.4219 0.46875 21.8945L13.1836 1.62109C13.5352 1.03516 14.2383 0.625 15 0.625C15.7031 0.625 16.4062 1.03516 16.7578 1.62109L29.4727 21.8945C29.8242 22.4219 30 23.0078 30 23.6523C30 25.4102 28.5352 26.875 26.7188 26.875H3.22266Z",
    fill: "#0D63CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconThrill);
export default __webpack_public_path__ + "static/media/icon_thrill.d413e8dc340c450a2dac6246b7f49477.svg";
export { ForwardRef as ReactComponent };